{
  "tabs": {
    "chat": "Waxtaan",
    "reminders": "Xam-xam",
    "calendar": "Kalandar",
    "settings": "Jëfandikukat"
  },
  "common": {
    "cancel": "Topp",
    "save": "Jëfandikoo",
    "confirm": "Jàpp",
    "delete": "Soppaliku",
    "back": "Benn",
    "close": "Tëj",
    "edit": "Sax",
    "search": "Sàkk",
    "all": "Boo ko defee",
    "loading": "Jël...",
    "error": "Lu amul benn ndigal",
    "notFound": "Amul",
    "tryAgain": "Jàppale bopp",
    "retry": "Jàppale",
    "undo": "Toppaliku",
    "pullToRefresh": "Tànn ngir jëfandikoo",
    "justNow": "Benn bés"
  },
  "auth": {
    "welcome": "Bëgg nga FishMemory",
    "tagline": "Jàmmu WhatsApp, jëfandikoo ci pocket bi.",
    "subtitle": "Jàmmu WhatsApp, jëfandikoo ci pocket bi.",
    "phoneLabel": "Numéro WhatsApp bi",
    "phoneHint": "Dinaa jëfandikoo code ci WhatsApp",
    "invalidPhone": "Jël numéro bu am solo",
    "continue": "Jàppale",
    "enterPhone": "Jël numéro WhatsApp bi",
    "phonePlaceholder": "Numéro",
    "sendCode": "Jël Code",
    "verifyTitle": "Jàppale numéro bi",
    "otpSentTo": "Code 6-chiffres dinaa jël ci {{phone}} ci WhatsApp",
    "enterFullCode": "Jël 6 chiffres yi",
    "invalidOtp": "Code bu amul solo. Jàppale.",
    "otpFailed": "Jël code du am solo. Jàppale.",
    "otpResent": "Code jël weer",
    "resendIn": "Jël weer ci {{seconds}}s",
    "resendCode": "Jël code weer",
    "enterOtp": "Jël code bi jël ci WhatsApp bi",
    "verify": "Jàppale",
    "resend": "Jël code weer",
    "wrongNumber": "Numéro bu amul solo?",
    "backToPhone": "Benn ci numéro",
    "editPhone": "Sax numéro bi",
    "error": "Ndigal",
    "setupTitle": "Nangu jëfandikoo",
    "setupSubtitle": "Dinaa mën a sax ci Jëfandikukat",
    "namePlaceholder": "Sa tur",
    "letsGo": "Jël setup",
    "skipForNow": "Toppaliku ci biir"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Tëj benn xibaar...",
    "inputPlaceholder": "Tëj benn xibaar...",
    "typing": "FishMemory dafa bëgg tëj xibaar...",
    "online": "Ci internet",
    "connecting": "Jàppale...",
    "reconnecting": "Jàppale weer...",
    "offline": "Boo ci internet",
    "empty": "Tëj benn waxtaan",
    "emptyHint": "Sax xam-xam, jàngal kalandar, walla jëfandikoo ndimbal.",
    "emptyAction": "Jël xam-xam bu neex",
    "actions": "Jëfandikukat waxtaan",
    "keep": "Jëfandikoo xibaar yi",
    "clearTitle": "Soppaliku waxtaan",
    "clearConfirm": "Soppaliku xibaar yi ci dëkk bi? Du mën a topp.",
    "clear": "Soppaliku waxtaan",
    "optionSelected": "Sax: {{label}}",
    "sendingSelection": "Jël...",
    "connectionLost": "Jàppale weer..."
  },
  "reminders": {
    "title": "Xam-xam yi",
    "active": "Am solo",
    "today": "Bés bi",
    "thisWeek": "Simili bi",
    "history": "Taarix",
    "items": "benn",
    "emptyTitle": "Amul xam-xam",
    "emptySubtitle": "Sax benn ci waxtaan, dina am ci biir.",
    "emptyAction": "Tëj waxtaan",
    "filterActive": "Am solo",
    "filterToday": "Bés bi",
    "filterWeek": "Simili bi",
    "filterHistory": "Taarix",
    "emptyState": "Amul xam-xam. Tëj waxtaan!",
    "swipeDone": "Dëgg",
    "swipeSnooze": "Toppaliku",
    "swipeDelete": "Soppaliku",
    "search": "Sàkk xam-xam...",
    "upcoming": "Benn",
    "completed": "Dëgg",
    "overdue": "Jàppale",
    "tomorrow": "Bés bu nekk",
    "synced": "Sax {{value}}",
    "swipeHint": "Tànn xam-xam ngir jëfandikukat yu bari",
    "noResults": "Amul xam-xam bu am solo",
    "noResultsHint": "Jàppale benn xibaar walla soppi sàkk bi",
    "deleteAllFailed": "Du am solo ci soppaliku xam-xam yi"
  },
  "calendar": {
    "title": "Kalandar",
    "today": "Bés bi",
    "tomorrow": "Bés bu nekk",
    "completed": "Dëgg",
    "noEvents": "Amul benn ndimbal",
    "noEventsSubtitle": "Soxla bés ngir gis xam-xam ak ndimbal yi.",
    "googleEvent": "Google Kalandar",
    "legendActive": "Am solo",
    "legendRecurring": "Dëggal",
    "legendDone": "Dëgg",
    "legendGoogle": "Google",
    "previousMonth": "Wàll bés",
    "nextMonth": "Bés bu nekk",
    "previousYear": "Wàll at",
    "nextYear": "At bu nekk",
    "goToToday": "Dem ci bés bi",
    "all": "Boo ko defee",
    "active": "Am solo",
    "done": "Dëgg",
    "paused": "Toppaliku"
  },
  "settings": {
    "title": "Jëfandikukat",
    "profile": "Jàngalekat",
    "name": "Tur bu am solo",
    "enterName": "Jël sa tur",
    "language": "Liggéey",
    "uiLanguage": "Liggéey app bi",
    "uiLanguageHelp": "Sax app bi, kalandar ak jëfandikukat ci dëkk bi.",
    "serverLanguage": "Liggéey waxtaan",
    "serverLanguageHelp": "Sax liggéey bi server bi jëfandikoo ci waxtaan yi.",
    "timezone": "Waxtu",
    "currentTimezone": "Waxtu bu am solo",
    "timezoneHelp": "Benn waxtu ci xam-xam yi am ci waxtu bi.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Jëfandikoo waxtu",
    "timezoneSaved": "Waxtu sax",
    "detect": "Gis",
    "detectFailed": "Du am solo ci gis waxtu",
    "autoDetect": "Gis ci GPS",
    "notifications": "Jàngaliku",
    "notificationsHelp": "Xam-xam yi jàngaliku ci jàngaliku yi. Jàngaliku ci dëkk bi am ci jëfandikukat bi.",
    "pushEnabled": "Jàngaliku Push",
    "autoDoneOnFire": "Dëggal bu nekk ci jàngaliku",
    "autoDoneOnFireDesc": "Su amul, xam-xam yi am solo ba nga dëggal.",
    "googleCalendar": "Google Kalandar",
    "google": "Google Kalandar",
    "googleConnected": "Jàppale",
    "googleDisconnected": "Du jàppale",
    "googleConnectedHelp": "Xam-xam yu bees mën a jàppale ci kalandar bi.",
    "googleDisconnectedHelp": "Jàppale Google Kalandar ngir jàppale xam-xam ak ndimbal yi.",
    "googleConnectFailed": "Du am solo ci jàppale Google Kalandar",
    "connected": "Jàppale",
    "disconnected": "Du jàppale",
    "connect": "Jàppale",
    "disconnect": "Toppaliku",
    "autoSync": "Jàppale xam-xam yu bees",
    "autosync": "Jàppale xam-xam yu bees",
    "subscription": "Jëfandikukat",
    "trialUsed": "Jàppale: {{used}}/{{total}} jàppale",
    "trialStatus": "Jàppale am",
    "activeStatus": "Jëfandikukat am solo",
    "expiredStatus": "Jëfandikukat du am solo",
    "unsubscribedStatus": "Du jëfandikukat",
    "about": "Ci biir",
    "version": "Version",
    "logout": "Jëfandikoo",
    "logoutTitle": "Jëfandikoo",
    "logoutConfirm": "Dama bëgg jëfandikoo?",
    "noName": "Amul tur",
    "serverConnection": "Jàppale server",
    "serverUrl": "URL server",
    "serverEdit": "Sax",
    "saveReconnect": "Jëfandikoo ak jàppale weer",
    "resetDefault": "Soppaliku bu bees",
    "invalidServerUrlTitle": "URL server bu amul solo",
    "invalidServerUrlMessage": "Jël URL server bu am solo, ci misaal https://example.com",
    "uiLanguageChangeFailed": "Du am solo ci sax liggéey app bi. Jàppale.",
    "serverLanguageChangeFailed": "Du am solo ci sax liggéey waxtaan bi. Jàppale.",
    "timezoneChangeFailed": "Du am solo ci sax waxtu bi. Jàppale.",
    "autoSyncChangeFailed": "Du am solo ci sax jàppale xam-xam yi. Jàppale.",
    "nameChangeFailed": "Du am solo ci sax tur bi. Jàppale.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Benn xam-xam",
    "editTime": "Sax waxtu",
    "rename": "Sax tur",
    "snooze": "Toppaliku",
    "snooze15": "Toppaliku 15 minit",
    "pause": "Toppaliku",
    "pauseReminder": "Toppaliku xam-xam bi",
    "resume": "Jàppale",
    "resumeReminder": "Jàppale xam-xam bi",
    "skip": "Toppaliku benn",
    "skipOccurrence": "Toppaliku benn bi",
    "syncGoogle": "Jàppale ci Google",
    "delete": "Soppaliku",
    "deleteTitle": "Soppaliku xam-xam bi",
    "deleteConfirm": "Xam-xam bii dinaa soppaliku bu baax.",
    "deleteRecurringTitle": "Soppaliku xam-xam yu dëggal",
    "deleteRecurringMessage": "Dama bëgg toppaliku benn walla soppaliku yeneen yi?",
    "deleteThisOccurrence": "Toppaliku benn",
    "deleteEntireSeries": "Soppaliku yeneen yi",
    "done": "Dëgg",
    "markDone": "Dëggal",
    "undo": "Toppaliku",
    "undoPrompt": "Bëgg nga am solo weer? Toppaliku.",
    "recurring": "Dëggal",
    "nextRun": "Benn jëfandikoo",
    "oneTime": "Benn bés",
    "pending": "Am solo",
    "sent": "Jël",
    "paused": "Toppaliku",
    "active": "Am solo",
    "snoozed": "Toppaliku",
    "localTime": "Jàng ci waxtu bi",
    "recurrence": "Dëggal",
    "created": "Sax",
    "tags": "Teg",
    "fireCount": "Ñaari waxtu",
    "actions": "Jëfandikukat",
    "none": "Amul",
    "snoozeFailed": "Du am solo ci toppaliku xam-xam bi",
    "pauseFailed": "Du am solo ci toppaliku xam-xam bi",
    "resumeFailed": "Du am solo ci jàppale xam-xam bi",
    "skipFailed": "Du am solo ci toppaliku xam-xam bi",
    "doneFailed": "Du am solo ci dëggal xam-xam bi",
    "undoFailed": "Du am solo ci toppaliku xam-xam bi",
    "deleteFailed": "Du am solo ci soppaliku xam-xam bi",
    "rescheduleTitle": "Jàppale weer?",
    "rescheduleMsg": "Xam-xam bii am solo. Dama bëgg jàppale weer?",
    "reschedule15": "Ci 15 minit",
    "reschedule60": "Ci 1 waxtu",
    "keepOverdue": "Jëfandikoo ni mu am solo"
  },
  "onboarding": {
    "slide1Title": "Bëgg nga FishMemory",
    "slide1Sub": "Jàmmu xam-xam bi — jëfandikoo WhatsApp ak pocket bi.",
    "slide2Title": "Waxtaan ci wàllu bu neex",
    "slide2Sub": "Tëj xam-xam ni nga bëgg: \"Xam naa nga jël xam-xam ngir waxtu bi\" — nu mën a jëfandikoo.",
    "slide3Title": "Du am solo",
    "slide3Sub": "Jàngaliku ci waxtu, jëfandikoo teg, ak jàppale lu am solo.",
    "getStarted": "Jàppale",
    "next": "Benn",
    "firstReminderTitle": "Tëj xam-xam bi",
    "firstReminderHint": "Jàppale benn ni:",
    "firstReminderExample": "Xam naa nga jël xam-xam ngir ndox bés bu nekk ci 9 AM",
    "gotIt": "Am naa!",
    "notifRationaleTitle": "Jàppale ci waxtu",
    "notifRationaleBody": "FishMemory dafa am jàngaliku ngir xam-xam ci waxtu. Dinaa am jàngaliku ci xam-xam yi nga jëfandikoo.",
    "notifRationaleAllow": "Jàngaliku jëfandikoo",
    "notifRationaleLater": "Benn waxtu",
    "swipeHint": "Tànn benn ngir jëfandikukat →",
    "calendarDragHint": "Tànn ngir gën a am ↕"
  }
}
